/**
 * JS for single collection
 */

import * as lpUtils from '../utils.js';

// Rest API Enroll Collection
const enrollCollection = ( e, target ) => {
	e.preventDefault();

	if ( ! target.classList.contains('lp-form-collection-enroll') ) {
		return;
	}

	const btnEnroll = target.querySelector( '.lp-btn-collection-enroll' );
	const formData = new FormData( target )
	const dataSend = {
		action: 'enroll_collection',
		args: {
			id_url: 'enroll-collection',
		},
	};

	for ( const [key, value] of formData.entries() ) {
		if ( ! dataSend.hasOwnProperty( key ) ) {
			let value_convert = value;
			if ( 'object' === typeof value ) {
				value_convert = value.join( ',' );
			}
			dataSend[ key ] = value_convert;
		}
	}

	// AJax enroll collection
	const callBack = {
		success: ( response ) => {
			const {
				status,
				data: { redirect },
				message,
			} = response;

			if( btnEnroll ) {
				btnEnroll.remove();
			}

			if ( message && status ) {
				target.innerHTML += `<div class="learn-press-message ${ status }">${ message }</div>`;
				if ( redirect ) {
					window.location.href = redirect;
				}
			}
		},
		error: ( error ) => {
			console.log( error );
		},
		completed: () => {
		},
	};

	lpUtils.lpSetLoadingEl( btnEnroll, 1 );
	window.lpAJAXG.fetchAJAX( dataSend, callBack );
};

document.addEventListener( 'submit', ( e ) => {
	const target = e.target;
	enrollCollection( e, target );
} );
